// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3AR5N","header":"PatientBlock_header__2MLbW","label":"PatientBlock_label__2GAc0","option":"PatientBlock_option__1OwXu"};